// Phase 7: Kennzeichen aus CSV/Klartext importieren. Nur dieser Weg, nicht
// das native Format der Original-App - siehe Server-Kommentar in
// api/src/routes/collections.ts fuer die Begruendung.
//
// Ein Stueck kann sein Land mitbringen ("PL:ZS"); ohne Vorsatz gilt
// Deutschland. Zerlegt wird das erst auf dem Server (lib/import.ts), hier
// werden die Stuecke nur getrennt.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "./api.js";

/**
 * Zerlegt eingefuegten Text oder eine CSV-Datei in einzelne Codes.
 * Trennzeichen sind Kommas, Zeilenumbrueche, Semikolons und Leerraum, so
 * frei wie moeglich, weil niemand sich an ein Format halten wird.
 */
export function parseCodesEingabe(text: string): string[] {
  const gefunden = text
    .split(/[,;\n\r\t ]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return [...new Set(gefunden)];
}

export interface ImportErgebnis {
  importiert: number;
  bereitsVorhanden: number;
  unbekannt: string[];
}

export function useImportieren(sammlungId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (codes: string[]) =>
      api<ImportErgebnis>(`/collections/${sammlungId}/import`, { method: "POST", body: { codes } }),
    onSuccess: () => {
      if (sammlungId !== undefined) void queryClient.invalidateQueries({ queryKey: ["entries", sammlungId] });
    },
  });
}
